import type { HealthStatus } from '../domain/types';
export function StatusPill({ status }: { status: HealthStatus }) {
  return <span className={`status status-${status.toLowerCase()}`}>{status === 'OUT' ? 'Out' : status === 'LOW' ? 'Low' : status === 'OK' ? 'OK' : 'Unknown'}</span>;
}
